// extracted by mini-css-extract-plugin
export default {"info":"VerticalItemList_info__BvbCM"};